import * as Sentry from '@sentry/capacitor'
import * as SentryReact from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloProvider } from '@apollo/client/react'
import '@fontsource/plus-jakarta-sans/400.css'
import '@fontsource/plus-jakarta-sans/500.css'
import '@fontsource/plus-jakarta-sans/600.css'
import '@fontsource/plus-jakarta-sans/700.css'
import App from './App.tsx'
import { apolloClient } from './lib/apollo.ts'
import './lib/posthog'
import { IonApp, setupIonicReact } from '@ionic/react'
import { IonReactRouter } from '@ionic/react-router'
import { Auth0ProviderWithNavigate } from './auth0-provider-with-navigate.tsx'
import { UserAccountProvider } from './contexts/UserAccountContext.tsx'
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext.tsx'
import { AppConfigProvider } from './contexts/AppConfigContext.tsx'
import { AppInitializer } from './components/AppInitializer.tsx'
import { PushNotificationInitializer } from './components/PushNotificationInitializer.tsx'
import { capacitorFetch } from './utils/capacitorFetch'
import { Capacitor } from '@capacitor/core'
import config from './config'

Sentry.init(
  {
    dsn: config.sentryDsn,
    environment: import.meta.env.MODE,
    enabled: !!config.sentryDsn,
    denyUrls: [
      /chrome-extension:\/\//i,
      /extensions\//i,
    ],
  },
  SentryReact.init,
)

import '@ionic/react/css/core.css'
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'
import '@ionic/react/css/padding.css'
import '@ionic/react/css/float-elements.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/display.css'
import './index.css'

// Override fetch on mobile to use Capacitor HTTP (bypasses CORS)
if (Capacitor.isNativePlatform()) {
  window.fetch = capacitorFetch as typeof fetch;
}

setupIonicReact({ backButtonText: 'Atrás' })

import { defineCustomElements } from '@ionic/pwa-elements/loader';
defineCustomElements(window);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryReact.ErrorBoundary fallback={<div>Algo salió mal</div>}>
      <ApolloProvider client={apolloClient}>
        <IonApp>
          <IonReactRouter>
            <Auth0ProviderWithNavigate>
              <UserAccountProvider>
                <FeatureFlagsProvider>
                  <AppConfigProvider>
                    <AppInitializer>
                      <PushNotificationInitializer />
                      <App />
                    </AppInitializer>
                  </AppConfigProvider>
                </FeatureFlagsProvider>
              </UserAccountProvider>
            </Auth0ProviderWithNavigate>
          </IonReactRouter>
        </IonApp>
      </ApolloProvider>
    </SentryReact.ErrorBoundary>
  </StrictMode>,
)
